module.exports = __webpack_public_path__ + "img/engagement.acfdda3f.svg";